import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { validarPace } from "./validateForm";
import {
  getAnswersOfUser,
  saveAnswers,
} from "../../../services/rest/users/medicalQuestions";
import { handleError } from "../../../utils/handleError";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const TrainQuestionsModal = ({
  open,
  setOpen,
  setLoading,
  answers,
  setAnswers,
}) => {
  const { _id } = useSelector((state) => state.userReducer);
  const [questionsData, setQuestionsData] = React.useState({
    tiempoCorr: answers?.tiempoCorr ?? 0,
    pace: answers?.pace ?? "0:0",
    tipoEntrenamiento: answers?.tipoEntrenamiento ?? "Correr",
    participacion: answers?.participacion ?? "No",
    dispositivos: answers?.dispositivos ?? "No",
    distanciasKm: answers?.distanciasKm ?? "",
    tiemposMin: answers?.tiemposMin ?? 0,
    objetivoEsp: answers?.objetivoEsp ?? "",
  });
  const [error, setError] = React.useState("");
  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (field) => (event) => {
    setQuestionsData({ ...questionsData, [field]: event.target.value });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");

      const { mensaje, valido } = validarPace(questionsData?.pace);
      if (!valido) {
        setError(mensaje);
        setLoading(false);
        return;
      }

      const answersFormat = {
        section: "entrenamiento",
        userAnswers: questionsData,
      };
      await saveAnswers(answersFormat);
      const responseAnswers = await getAnswersOfUser(_id);
      // console.log("responses", responseAnswers);
      setAnswers(responseAnswers ?? {});
      setLoading(false);
      toast.success("Se guardaron con éxito sus respuestas");
      onClose();
    } catch (error) {
      const { message } = handleError(error);
      toast.error(
        `En estos momentos no se pudo guardar sus respuestas. \n ${message}`
      );
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Información de Entrenamiento</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3} sx={{ pt: 2 }}>
          {error && (
            <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="¿Cuánto tiempo llevas corriendo? (En meses)"
              type="number"
              value={questionsData.tiempoCorr}
              onChange={handleChange("tiempoCorr")}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="¿Cuál es tu pace por kilómetro? (5:10)"
              value={questionsData.pace}
              onChange={handleChange("pace")}
              error={!!error}
              helperText="Formato mm:ss"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Qué tipo de entrenamiento realizas? (Correr en pista, montaña, cinta, etc.)"
              value={questionsData.tipoEntrenamiento}
              onChange={handleChange("tipoEntrenamiento")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Has participado en competencias? (Carreras de 5K, 10K, maratones, etc.)"
              value={questionsData.participacion}
              onChange={handleChange("participacion")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Utilizas algún dispositivo para medir tu rendimiento? (Reloj, apps, etc.)"
              value={questionsData.dispositivos}
              onChange={handleChange("dispositivos")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="¿Qué distancias manejas actualmente? (Ingresa en Km)"
              type="number"
              value={questionsData.distanciasKm}
              onChange={handleChange("distanciasKm")}
              inputProps={{ step: "0.1", min: 0 }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="¿Qué tiempos manejas actualmente? (Ingresa en min)"
              type="number"
              value={questionsData.tiemposMin}
              onChange={handleChange("tiemposMin")}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Tienes algún objetivo específico en el running? (Maratón, mejorar tiempos, etc.)"
              value={questionsData.objetivoEsp}
              onChange={handleChange("objetivoEsp")}
              multiline
              rows={3}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} variant="outlined" color="white">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrainQuestionsModal;
